import { createContext, useContext } from "react";

const SidePanelReadOnlyContext = createContext(false);

export const useSidePanelReadOnly = () => useContext(SidePanelReadOnlyContext);

export default SidePanelReadOnlyContext;
